import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, Menu, X, Facebook, Instagram } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/", label: "ACCUEIL" },
    { to: "/vehicules", label: "PORSCHE MACAN" },
    { to: "/#services", label: "SERVICES" },
    { to: "/#about", label: "À PROPOS" },
    { to: "/#contact", label: "CONTACTEZ-NOUS" },
  ];

  return (
    <>
      {/* Top bar */}
      <div className="hidden md:flex bg-[#1a1a1a] text-gray-300 text-xs px-6 py-2 justify-between items-center">
        <div className="flex items-center gap-6">
          <a href="mailto:contact@rmlocation.re" className="flex items-center gap-1.5 hover:text-[#D4A843] transition-colors">
            <Mail size={11} /> contact@rmlocation.re
          </a>
          <a href="tel:0692042073" className="flex items-center gap-1.5 hover:text-[#D4A843] transition-colors">
            <Phone size={11} /> Devis urgent : 0692 04 20 73
          </a>
        </div>
        <span className="text-gray-400 italic">Notre mission est de vous offrir un service premium</span>
        <div className="flex items-center gap-3">
          <a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="hover:text-[#D4A843] transition-colors"><Facebook size={13} /></a>
          <a href="https://www.instagram.com" target="_blank" rel="noreferrer" className="hover:text-[#D4A843] transition-colors"><Instagram size={13} /></a>
        </div>
      </div>

      {/* Main navbar */}
      <nav className="sticky top-0 left-0 right-0 z-50 bg-white/97 backdrop-blur-sm border-b border-gray-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src="https://rmlocation.re/wp-content/uploads/2025/11/cropped-RM-Location-3-1-e1730841979378.png"
                alt="RM Location Prestige" className="h-12 w-auto"
                onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }} />
              <span className="hidden" style={{display:'none'}}>
                <span className="text-xl font-bold text-gray-900 tracking-tight">RM Location</span>
                <span className="text-xs font-medium text-[#D4A843] tracking-widest ml-1">PRESTIGE</span>
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-7">
              {links.map(l => (
                l.to.startsWith("/#") ? (
                  <a key={l.to} href={l.to}
                    onClick={(e) => {
                      e.preventDefault();
                      const id = l.to.replace("/#", "");
                      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className={`text-xs font-semibold tracking-widest transition-colors cursor-pointer ${
                      location.pathname === l.to ? "text-[#D4A843]" : "text-gray-700 hover:text-[#D4A843]"
                    }`}>
                    {l.label}
                  </a>
                ) : (
                  <Link key={l.to} to={l.to} className={`text-xs font-semibold tracking-widest transition-colors ${
                    location.pathname === l.to ? "text-[#D4A843]" : "text-gray-700 hover:text-[#D4A843]"
                  }`}>
                    {l.label}
                  </Link>
                )
              ))}
              <Link to="/reservation" data-testid="nav-reserver-btn"
                className="px-5 py-2.5 bg-[#D4A843] text-white text-xs font-bold tracking-widest uppercase hover:bg-[#c49933] transition-colors">
                RÉSERVER MA DATE
              </Link>
            </div>

            <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-3">
            <Link to="/" onClick={() => setOpen(false)} className="block text-sm font-semibold tracking-widest text-gray-700 hover:text-[#D4A843] py-2">ACCUEIL</Link>
            <Link to="/vehicules" onClick={() => setOpen(false)} className="block text-sm font-semibold tracking-widest text-gray-700 hover:text-[#D4A843] py-2">PORSCHE MACAN</Link>
            {["services","about","contact"].map(id => (
              <a key={id} href={`#${id}`} onClick={() => setOpen(false)}
                className="block text-sm font-semibold tracking-widest text-gray-700 hover:text-[#D4A843] py-2 uppercase">
                {id === "about" ? "À PROPOS" : id === "contact" ? "CONTACTEZ-NOUS" : "SERVICES"}
              </a>
            ))}
            <Link to="/reservation" onClick={() => setOpen(false)}
              className="block w-full text-center py-3 bg-[#D4A843] text-white text-sm font-bold tracking-widest uppercase">
              RÉSERVER MA DATE
            </Link>
            <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
              <a href="tel:0692042073" className="flex items-center gap-1.5 text-[#D4A843] text-sm font-medium">
                <Phone size={14} /> 0692 04 20 73
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
